import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-parent',
  templateUrl: './disable-parent.component.html',
  styleUrls: ['./disable-parent.component.css'],
})
export class DisableParentComponent {
  @Input() question!: Question;
}
